import type { Message, SavedChat } from "~/helpers/aiChat/chatStorage";

export interface ResumedChat {
	chatId: string;
	messages: Message[];
	sessionId: string | null;
}

const resolveResumedChat = (chats: SavedChat[], freshChatId: string, activeChatId: string | null): ResumedChat => {
	const chat = activeChatId
		? chats.find((candidate) => candidate.id === activeChatId && candidate.messages.length > 0)
		: undefined;
	if (!chat) return { chatId: freshChatId, messages: [], sessionId: null };
	return { chatId: chat.id, messages: chat.messages, sessionId: chat.sessionId };
};

export default resolveResumedChat;
